import locale from "localization";
import styles from "./shift-details-stock-inventory.module.scss";
import { Title } from "components/commons";
import { dryStockSalesMapper } from "./shift-details-stock-inventory.mapper";
import { dryStockLubricantSalesColumn } from "./shift-details-stock-inventory-column";
import useDataTable from "hooks/useDataTable";
import { initialFilterState } from "modules/shift-records/shift-records-filter.state";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { filter } from "lodash";
import Big from "big.js";

const ShiftDetailsDryStockSalesLubricant = ({ shift, allProducts }) => {
  const isLubricant = true;
  const lubricants = filter(shift?.transactionItem.nonFuel, { type: "lubricant" });

  const products = new Map(allProducts.map((p) => [p.sku, p]));

  const formattedList = lubricants
    .map((lubricant) => {
      const product = products.get(lubricant.sku);
      // const totalDiscount = lubricant?.originalTotalAmount - lubricant?.netTotalAmount;

      // const premiumDiscount = lubricantsPremiumDiscount.find(
      //   (premium) => premium.sku === lubricant.sku
      // );

      // // STOCQ-5847: a lubricant can be BOTH Tax VAT Exempt AND have a transaction discount
      // // (the prior check `vat === 0 && totalDiscount === 0` missed this case, leaving
      // // VAT Exempt at 0 and the Final Amount at original−discount instead of using the
      // // POS-stored net). Detect via the dedicated isTaxVatExemptItem signal and use the
      // // stored netTotalAmount / vatExempt fields directly.
      // const isLubeTaxVatExempt = isTaxVatExemptItem(lubricant);
      // const isLegacyVatExempt =
      //   !isLubeTaxVatExempt && lubricant.vat === 0 && lubricant.totalDiscount === 0;
      // // const totalDiscount = isLegacyVatExempt ? 0 : Math.abs(lubricant.totalDiscount ?? 0);
      // let totalDiscount = lubricant.totalDiscount;
      // let finalAmount;
      // let vatExemptAmount;
      // if (isLubeTaxVatExempt) {
      //   vatExemptAmount = -computeTaxVatExemptMagnitude(lubricant);
      //   finalAmount =
      //     lubricant.netTotalAmount != null
      //       ? lubricant.netTotalAmount
      //       : lubricant.originalTotalAmount + totalDiscount + vatExemptAmount;
      // } else if (isLegacyVatExempt) {
      //   const vatAdjustment = lubricant.originalTotalAmount - lubricant.originalTotalAmount / 1.12;
      //   finalAmount = lubricant.originalTotalAmount - vatAdjustment;
      //   vatExemptAmount = -vatAdjustment;
      // } else {
      //   // STOCQ-1866: lubricant.totalDiscount sign varies across shifts (manual/offline
      //   // stores +magnitude, regular online stores either sign). Derive the true
      //   // discount magnitude from original − net so the column shows "-" for discounts
      //   // and finalAmount uses the POS-authoritative netTotalAmount.
      //   const discountMagnitude =
      //     (lubricant.originalTotalAmount ?? 0) -
      //     (lubricant.netTotalAmount ?? lubricant.originalTotalAmount ?? 0);
      //   totalDiscount = -discountMagnitude;
      //   finalAmount =
      //     lubricant.netTotalAmount != null
      //       ? lubricant.netTotalAmount
      //       : lubricant.originalTotalAmount - discountMagnitude;
      //   vatExemptAmount = 0;
      // }

      let totalDiscount = Number(
        Big(lubricant.originalTotalAmount)
          .minus(lubricant.netTotalAmount)
          .minus(Math.abs(lubricant.vatExempt12percent))
          .mul(-1)
          .round(2)
      );

      let vatExemptAmount = lubricant.vatExempt12percent;
      const finalAmount = lubricant.originalTotalAmount + totalDiscount + vatExemptAmount;

      return {
        ...lubricant,
        totalDiscount,
        finalAmount,
        category: product?.category?.name || "-",
        vatExemptAmount,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  console.log("formattedList", formattedList);

  const { table } = useDataTable({
    value: formattedList,
    filter: { initialState: initialFilterState(), mapper: (val) => val },
    table: {
      key: "nonFuel",
      name: "dryStockSales",
      mapper: (val) => dryStockSalesMapper({ val, isLubricant }),
      columns: dryStockLubricantSalesColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.lubricantSales}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsDryStockSalesLubricant;
